/**
 * SMA-100. Turning a stored cancellation reason into something readable.
 *
 * A value the API returns that we do not know is NOT folded into « other »:
 * that would quietly rewrite the past the day a reason is renamed or dropped.
 * It keeps its own slice and shows its raw value, which is ugly on purpose,
 * because an ugly slice gets fixed and a silent lie does not.
 */
const LABEL_KEYS: Record<string, string> = {
  weather: 'activitiesManagement.reasonWeather',
  not_enough_registrations: 'activitiesManagement.reasonNotEnoughRegistrations',
  organiser_unavailable: 'activitiesManagement.reasonOrganiserUnavailable',
  venue_unavailable: 'activitiesManagement.reasonVenueUnavailable',
  other: 'activitiesManagement.reasonOther',
  not_asked: 'activitiesManagement.reasonNotAsked',
};

export const cancellationReasonLabelKey = (reason: string): string =>
  LABEL_KEYS[reason] ?? reason;

/** Smatchy palette, with the grey kept for the ones nobody was asked about. */
export const CANCELLATION_REASON_COLOURS: Record<string, string> = {
  weather: '#479e9c',
  not_enough_registrations: '#0a4a60',
  organiser_unavailable: '#fca13b',
  venue_unavailable: '#9fd0ce',
  other: '#c2683c',
  not_asked: '#c3d3d8',
};
